import { PropertyAddress } from "models/FullApplication"

export const formatPropertyAddress = (address: PropertyAddress | null): string => {
  const formatted = [address?.nameNumber, address?.street].filter(Boolean).join(" ")

  return formatted || "TBC"
}
